import { action } from 'typesafe-actions';
import { StorageKeys } from './../helpers/localStorage';
import { NotifKind } from '../reducers/notifications';

const entity = 'notifs';
export const NOTIF_SEND = `${entity}/NOTIF_SEND`;
export const NOTIF_DISMISS = `${entity}/NOTIF_DISMISS`;
export const NOTIF_CLEAR = `${entity}/NOTIF_CLEAR`;

const actionCreateNotification = ({
  kind = 'info',
  dismissAfter = 10000,
  message,
  title,
}: {
  kind?: NotifKind;
  dismissAfter?: number;
  message: string | number;
  title?: string;
}) => {
  const payload = {
    kind,
    dismissAfter,
    id: Date.now(),
    message,
    title,
  };
  try {
    const previousLogs =
      window.sessionStorage.getItem(StorageKeys.notifications_log) || '[]';
    window.sessionStorage.setItem(
      StorageKeys.notifications_log,
      JSON.stringify([payload, ...JSON.parse(previousLogs)])
    );
  } catch (err) {
    console.error(err);
  }
  return action(NOTIF_SEND, payload);
};

/**
 * Dismiss a notification by the given id.
 */
const notifDismiss = (id: number) => action(NOTIF_DISMISS, id);

/**
 * Clear all notifications
 */
const notifClear = () => action(NOTIF_CLEAR);

export { actionCreateNotification, notifDismiss, notifClear };
